// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_catalog_catalog-routing_module_ts":"c40e77994ca4e88f","src_app_cartographie_cartographie-routing_module_ts":"3c330db5b45bdabb","node_modules_dompurify_dist_purify_es_mjs":"30e6fd7df2b7a888","node_modules_canvg_lib_index_es_js":"60c443bea287b3dc"}[chunkId] + ".js";
};